import { startLoading, setUserOrganization } from "./userOrganizationSlice";
import axios from "axios";
import { zynity_api } from "../../config/external-routes";
import { constants } from "../../config/constants";

const isLocalEnv = process.env.REACT_APP_ENV === constants.envs.local;

/** Empty payload so Body renders "No organizations" and isLoading becomes false */
const emptyOrgsPayload = { data: [] };

export const getUserOrganizations = () => {
    return async (dispatch: (arg0: { payload: any; type: string }) => void, state: any) => {
        const user = state().auth;

        if (isLocalEnv && (user?.id === 0 || user?.id == null)) {
            dispatch(setUserOrganization(emptyOrgsPayload));
            return;
        }

        dispatch(startLoading());
        axios.defaults.headers.common = {
            Authorization: `Bearer ${user.access_token}`,
        };

        const authHeader = { headers: { Authorization: `Bearer ${user.access_token}` } };
        const lightUrl = zynity_api.get_user_organization_light.replace("{user_id}", user.id);
        const fullUrl = zynity_api.get_user_organization.replace("{user_id}", user.id);

        try {
            const [lightRes, fullRes] = await Promise.all([
                axios.get(lightUrl, authHeader),
                axios.get(fullUrl, authHeader),
            ]);
            dispatch(setUserOrganization(fullRes.data ?? lightRes.data));
        } catch {
            dispatch(setUserOrganization(emptyOrgsPayload));
        }
    };
};
